import { FirebaseConfig } from "./firebaseConfig";
import { HideDevTools } from "./hide";

const features = [HideDevTools, FirebaseConfig];

export default features;
